import React from 'react';
import HeadingBlock from '$/components/global/heading';
import PendingApprovalGrid from '$/components/pending-approval-grid';

const PendingApproval: React.FC<any> = () => {
  return (
    <React.Fragment>
      <section>
        <div className="pending-approval">
          <HeadingBlock title={'Manage Docs Pending Approval'} />
          <PendingApprovalGrid />
        </div>
      </section>
    </React.Fragment>
  );
};

export default PendingApproval;
